export enum ActiveTab {
  ACTIVITIES = 'ACTIVITIES',
  BASIC = 'BASIC',
  TIMESHEET = 'TIMESHEET',
  DELEGATIONS = 'DELEGATIONS',
  VIOLATIONS = 'VIOLATIONS',
  PRINTOUT_GENERATE = 'PRINTOUT_GENERATE',
  PRINTOUT_DOWNLOAD = 'PRINTOUT_DOWNLOAD',

  VEHICLE_ACTIVITIES = 'VEHICLE_ACTIVITIES',
  VEHICLE_BASIC = 'VEHICLE_BASIC',

  IMPORT_TO_SEND = 'IMPORT_TO_SEND',
  IMPORT_SENT = 'IMPORT_SENT',

  EXPORT = 'EXPORT',

  NEW_DELEGATION_EVENT = 'NEW_DELEGATION_EVENT',
  NEW_DELEGATION_ALLOWANCE = 'NEW_DELEGATION_ALLOWANCE',
  NEW_DELEGATION_ACCOMODATION = 'NEW_DELEGATION_ACCOMODATION',
  NEW_DELEGATION_INVOICE = 'NEW_DELEGATION_INVOICE',
  NEW_DELEGATION_ADVANCE_PAYMENT = 'NEW_DELEGATION_ADVANCE_PAYMENT',
  NEW_DELEGATION_ALLIMENTATION = 'NEW_DELEGATION_ALLIMENTATION',
  NEW_DELEGATION_SUMMARY = 'NEW_DELEGATION_SUMMARY',
  NEW_DELEGATION_ACTIVITY_CHART = 'NEW_DELEGATION_ACTIVITY_CHART',

  NEW_CONTRACT_CONTRACT_DATA = 'NEW_CONTRACT_CONTRACT_DATA',
  NEW_CONTRACT_LUMP_SUM_RATES = 'NEW_CONTRACT_LUMP_SUM_RATES',
  NEW_CONTRACT_MINIMAL_WAGE_QUALIFICATIONS = 'NEW_CONTRACT_MINIMAL_WAGE_QUALIFICATIONS',
  NEW_CONTRACT_OTHER_RATES = 'NEW_CONTRACT_OTHER_RATES',
  NEW_CONTRACT_LEAVES = 'NEW_CONTRACT_LEAVES',
  NEW_CONTRACT_TIMESHEET_BONUS_MODULE = 'NEW_CONTRACT_TIMESHEET_BONUS_MODULE',
  NEW_CONTRACT_ALLOWANCES_AND_DEDUCTIONS = 'NEW_CONTRACT_ALLOWANCES_AND_DEDUCTIONS',

  DRIVER_BASIC_DATA = 'DRIVER_BASIC_DATA',
  DRIVER_ADDITIONAL_DATA = 'DRIVER_ADDITIONAL_DATA',

  VEHICLE_BASIC_DATA = 'VEHICLE_BASIC_DATA',

  DRIVER_LIST = 'DRIVER_LIST',

  FILE_DETAILS_IMPORT = 'FILE_DETAILS_IMPORT',
  FILE_DETAILS_LOCKS = 'FILE_DETAILS_LOCKS',
  FILE_DETAILS_CALIBRATIONS = 'FILE_DETAILS_CALIBRATIONS',
  FILE_DETAILS_FAULTS = 'FILE_DETAILS_FAULTS',
  FILE_DETAILS_CONTROLS = 'FILE_DETAILS_CONTROLS',
  FILE_DETAILS_SIGNATURES = 'FILE_DETAILS_SIGNATURES',
  FILE_DETAILS_WARNINGS = 'FILE_DETAILS_WARNINGS',
  FILE_DETAILS_SPEED = 'FILE_DETAILS_SPEED',
}
